module.exports = __webpack_public_path__ + "/images/ico-vendedores-diana.9f2b08a.webp";